import Vue from 'vue';
export default {
  methods: {
    transformRecentCallsList: function (recentCallsList) {
      return [...recentCallsList].map(({ callLog, destination, callTag, user }) => {
        const {
          callDate,
          callerId,
          holdTime: callHoldTime,
          talkTime: callDuration,
          hangUpSide,
          id,
        } = callLog;

        const { firstName, lastName, userName } = user;
        const userFullName = firstName && lastName ? `${firstName} ${lastName}` : userName;
        const convertedDate = Vue.moment(callDate).format('jYYYY/jM/jD HH:mm:ss');
        let hangSideText = ''
        if (callLog.hangUpSide) {
          if (hangUpSide == 0) {
            hangSideText = 'تماس گیرنده';
          } else if (hangUpSide == 1) {
            hangSideText = 'پاسخ دهنده';
          } else {
            hangSideText = '-';
          }
        }
        return {
          callLogId: id,
          callDate: convertedDate ?? '...',
          fromTheNumber: callerId ?? '...',
          toTheNumber: destination ?? '...',
          callHoldTime: callHoldTime ?? '...',
          callDuration: callDuration ?? '...',
          hangUpSide: hangSideText ?? '...',
          result: callTag?.persianTitle ?? '...',
          userFullName,
        };
      });
    },
  },
};
